import { each, equals2, go, join, mapL, takeL } from "fxjs/es";
import { $$parsePathDateL } from "fxsvg";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const exportEditor = async (self, factor) => {
  self._checkNoProcessingTask();
  const layers_el = self._getLayersElThrowable();
  const background_layer_el = self._getBackgroundLayerElThrowable();
  const working_layer_el = self._getWorkingLayerElThrowable();
  const art_board = self._getArtBoardThrowable();
  const view_box_width = art_board.getWidth();
  const view_box_height = art_board.getHeight();
  const view_port_width = view_box_width * factor;
  const view_port_height = view_box_height * factor;
  const target_image_el = layers_el.cloneNode(false);
  target_image_el.setAttributeNS(null, "width", `${view_port_width}`);
  target_image_el.setAttributeNS(null, "height", `${view_port_height}`);
  target_image_el.setAttributeNS(
    null,
    "viewBox",
    `0 0 ${view_box_width} ${view_box_height}`
  );
  target_image_el.setAttributeNS(null, "style", `background-color: #FFFFFF;`);
  const clone_background_layer_el = await CommonNS.UtilNS.deepCloneNode(
    background_layer_el
  );
  target_image_el.appendChild(clone_background_layer_el);
  const clone_working_layer_el = working_layer_el.cloneNode(false);
  await go(
    self._els.values(),
    mapL(async ({ wrapper_el, clip_path_el, target_image_wrapper_el }) => {
      const clone_wrapper_el = wrapper_el.cloneNode(false);
      const defs_el = self._document.createElementNS(
        CommonNS.ConstNS.SVG_NAMESPACE,
        "defs"
      );
      defs_el.appendChild(await CommonNS.UtilNS.deepCloneNode(clip_path_el));
      clone_wrapper_el.appendChild(defs_el);
      clone_wrapper_el.appendChild(
        await CommonNS.UtilNS.deepCloneNode(target_image_wrapper_el)
      );
      return clone_wrapper_el;
    }),
    each((el) => clone_working_layer_el.appendChild(el))
  );
  target_image_el.appendChild(clone_working_layer_el);
  const cutting_line_el = layers_el.cloneNode(false);
  cutting_line_el.setAttributeNS(null, "width", `${view_port_width}`);
  cutting_line_el.setAttributeNS(null, "height", `${view_port_height}`);
  cutting_line_el.setAttributeNS(
    null,
    "viewBox",
    `0 0 ${view_box_width} ${view_box_height}`
  );
  await go(
    self._els.values(),
    mapL(({ cutting_line_path_data, wrapper_el }) => {
      const matrix =
        CommonNS.UtilNS.getConsolidatedTransformMatrix(wrapper_el) ??
        self._svg_el.createSVGMatrix();
      return go(
        cutting_line_path_data,
        $$parsePathDateL,
        mapL(({ command, parameters }) => {
          if (equals2(command)("M")) {
            const point = CommonNS.UtilNS.createSVGPoint(self._svg_el)(
              parameters
            ).matrixTransform(matrix);
            return `M ${point.x} ${point.y}`;
          }
          if (equals2(command)("L")) {
            const point = CommonNS.UtilNS.createSVGPoint(self._svg_el)(
              parameters
            ).matrixTransform(matrix);
            return `L ${point.x} ${point.y}`;
          }
          if (equals2(command)("C")) {
            return go(
              parameters,
              mapL(CommonNS.UtilNS.createSVGPoint(self._svg_el)),
              mapL((point) => point.matrixTransform(matrix)),
              mapL(({ x, y }) => `${x} ${y}`),
              join(" "),
              (ps) => `C ${ps}`
            );
          }
          if (equals2(command)("Q")) {
            return go(
              parameters,
              mapL(CommonNS.UtilNS.createSVGPoint(self._svg_el)),
              mapL((point) => point.matrixTransform(matrix)),
              mapL(({ x, y }) => `${x} ${y}`),
              join(" "),
              (ps) => `Q ${ps}`
            );
          }
          if (equals2(command)("A")) {
            const point = CommonNS.UtilNS.createSVGPoint(self._svg_el)([
              parameters[5],
              parameters[6],
            ]).matrixTransform(matrix);
            return go(
              parameters,
              takeL(5),
              join(" "),
              (ps) => `A ${ps} ${point.x} ${point.y}`
            );
          }
          if (equals2(command)("Z")) {
            return "Z";
          }
          throw new Error(`잘못된 path 정보입니다. : ${command} ${parameters}`);
        }),
        join(" ")
      );
    }),
    mapL((d) => {
      const path_el = self._document.createElementNS(
        CommonNS.ConstNS.SVG_NAMESPACE,
        "path"
      );
      path_el.setAttributeNS(null, "d", d);
      return path_el;
    }),
    each((el) => cutting_line_el.appendChild(el))
  );
  return {
    target_image_el,
    cutting_line_el,
  };
};
